<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
          label="背景模板名称"
          prop="advTitle"
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="背景模板名称"
            style="width: 200px;"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.sltype"
                  placeholder="人数类型"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="编号"
      >
        <template slot-scope="scope">
          {{scope.row.businessid}}
        </template>
      </el-table-column>

      <el-table-column
              label="窝单方"   v-if="is_agentid=='7080007'"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>


      <el-table-column
        label="背景模板名称"
        prop="businessname"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.businessname}}
        </template>
      </el-table-column>
      <el-table-column
              label="模板类型"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type=='1'">
            墓地模板
          </div>
          <div v-else-if="scope.row.type=='2'">
            灵堂模板
          </div>
          <div v-else-if="scope.row.type=='3'">
            宗亲模板
          </div>
          <div v-else-if="scope.row.type=='4'">
            祠堂模板
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="模板图片"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; " />
        </template>
      </el-table-column>
      <el-table-column
        label="排序"
        prop="sort_id"
        sortable="custom"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.sort_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="人数类型"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.sltype=='1'">
            单人
          </div>
          <div v-else-if="scope.row.sltype=='2'">
            双人
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
            禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openEditForm(scope.row)">编辑</el-button>
          <el-button type="primary" plain  size="mini"    @click="del(scope.row.id)">删除</el-button>
          <el-button
                  v-if="scope.row.state=='0'"
                  type="primary"
                  plain
                  size="mini"
                  @click="update(scope.row.id,1)"
          >禁用</el-button>
          <el-button
                  v-if="scope.row.state=='1'"
                  type="primary"
                  plain
                  size="mini"
                  @click="update(scope.row.id,0)"
          >恢复</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import util from '@/libs/util.js'
import editForm from "./editForm";
export default {
  name: "OneclassPage",
  components: { editForm },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      typeOptions2: [
        {
          value: "1",
          label: "单人"
        },
        {
          value: "2",
          label: "双人"
        }
      ],
        is_agentid:"",
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false
    };
  },
  mounted() {
      if(util.cookies.get('agentid')==null || util.cookies.get('agentid')==""){
          this.is_agentid="7080007";
      }else{
          this.is_agentid=util.cookies.get('agentid');
      }
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          xt_id:util.cookies.get('xt_id'),
        agentid:util.cookies.get('agentid'),
        fee:2,
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        oneclassService.getJzOneclassPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+row.imgpath;
      },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
      update(id,type){
          let msg = type == 1 ? "禁用" : "恢复";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              oneclassService.updateJzOneclass({id:id,state:type}).then(() => {
                  this.getTableData();
              });
          });
      },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService
          .delJzOneclasss({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          oneclassService.delJzOneclass({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
